import { createTranslations } from '@npco/common-utils-translations'

export const outstandingExpensesEmptyTranslations = createTranslations({
  title: 'You’re up to date with your expenses',
  description:
    'All of your expenses have been populated with the required information. Nice one!',
})
